import { render } from "./TabContainer.vue?vue&type=template&id=32e1999e&ts=true"
import script from "./TabContainer.vue?vue&type=script&lang=ts"
export * from "./TabContainer.vue?vue&type=script&lang=ts"

import "./TabContainer.vue?vue&type=style&index=0&id=32e1999e&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__